import React from 'react';

export default function PrivacyPolicyPage() {
  return (
    <div className="page-container privacy-page">
      <h1>Privacy Policy</h1>

      <p>
        We respect your privacy and are committed to protecting your personal information.
        This platform provides listings for cafés, restaurants, bars, clubs, and hotels,
        and we only collect data that is necessary to operate and improve our services.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We may collect basic information such as your name, email address, and account
        details when you create an account, submit reviews, save locations, or contact us.
      </p>

      <h2>How We Use Your Information</h2>
      <p>
        Your information is used to operate the platform, manage listings, improve user
        experience, respond to inquiries, and personalize recommendations for cafés,
        restaurants, bars, clubs, and hotels.
      </p>

      <h2>Location Data</h2>
      <p>
        If you allow location access, we may use your approximate location to show nearby
        venues and improve search results. You can disable location access at any time in
        your device or browser settings.
      </p>

      <h2>Reviews and User Content</h2>
      <p>
        Any reviews, ratings, photos, or comments you submit may be publicly visible on
        the platform. Please avoid sharing personal or sensitive information in public
        content.
      </p>

      <h2>Third-Party Services</h2>
      <p>
        We may use trusted third-party services such as analytics providers, map services,
        or authentication tools to help operate the platform. These services may process
        limited data in accordance with their own privacy policies.
      </p>

      <h2>Data Protection</h2>
      <p>
        We take reasonable measures to protect your personal data from unauthorized access,
        loss, or misuse.
      </p>

      <h2>Data Sharing</h2>
      <p>
        We do not sell your personal data to third parties. Information may only be shared
        when required to operate the platform, comply with legal obligations, or protect
        our users and services.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        This privacy policy may be updated from time to time. Continued use of the platform
        after changes indicates acceptance of the updated policy.
      </p>

      <h2>Contact</h2>
      <p>
        If you have questions about this Privacy Policy, please contact us through the
        platform’s contact page.
      </p>
    </div>
  );
}